import React, { createContext, useContext, useState } from 'react';

const now = new Date();

const ClinicDashboardContext = createContext({
    sharedMonthYear: { month: now.getMonth(), year: now.getFullYear() },
    setSharedMonthYear: () => {},
    sharedDate: { date: '' },
    setSharedDate: () => {},
});

export const ClinicDashboardProvider = ({ children }) => {
    const [sharedMonthYear, setSharedMonthYear] = useState({
        month: now.getMonth(),
        year: now.getFullYear()
    });
    const [sharedDate, setSharedDate] = useState({ date: '' });

    return (
        <ClinicDashboardContext.Provider value={{ sharedMonthYear, setSharedMonthYear, sharedDate, setSharedDate }}>
            {children}
        </ClinicDashboardContext.Provider>
    );
};

export const useClinicDashboard = () => useContext(ClinicDashboardContext);

export default ClinicDashboardContext;
